import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDocumentTitle } from 'usehooks-ts';
import { NewOutboundShipmentForm } from '@forms/NewOutboundShipmentForm';
import { NewOutboundShipmentFormValues } from '@forms/NewOutboundShipmentForm/types';

export function NewOutboundShipment() {
  useDocumentTitle('FLOX - New Outbound Shipment');
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const pages = [
    { name: 'Shipments', href: '/shipments', current: false },
    { name: 'Outbound Shipments', href: '/shipments', current: false },
    {
      name: 'Add Outbound Shipment',
      href: '/outbound-shipment/new',
      current: true,
    },
  ];

  const handleOnSubmit = async (data: NewOutboundShipmentFormValues) => {
    // eslint-disable-next-line no-console
    console.log('New Outbound Shipment Form Data:', data);
    setIsSubmitting(true);
    try {
      // TODO: Add API call to create outbound shipment
      // const { data: createShipmentData } = await authHttp.post(
      //   CREATE_OUTBOUND_SHIPMENT_URL,
      //   { shipment: data },
      //   { headers: { 'Content-Type': 'application/json' } }
      // );

      // Simulate API call
      await new Promise<void>((resolve) => {
        setTimeout(resolve, 1000);
      });

      // Navigate to shipment quote page
      // TODO: Use actual shipment ID from API response
      navigate('/shipments/5765-QT/quote');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error creating outbound shipment:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <NewOutboundShipmentForm
      onSubmit={handleOnSubmit}
      isSubmitting={isSubmitting}
      header='New Outbound Shipment'
      pages={pages}
    />
  );
}
